import React from "react";
import ClimateChart from "./ClimateChart";
import axios from "axios";
import { getHost } from "../utils";

import ImageGallery from "react-image-gallery";

import "react-image-gallery/styles/css/image-gallery.css";
import ReactMap from "../components/ReactMap";
import HotelAttributes from "./HotelAttributes";
import HotelRatings from "./HotelRatings";
import HotelReviews from "./HotelReviews";

export default function Hotelinfos(props) {
  const { hotelRegion, showInfo, catalogData, catIdx, hotel } = props;
  const [showInfoTab, setShowInfoTab] = React.useState("texts");

  const [catalogText, setCatalogText] = React.useState("");
  const [agbText, setAgbText] = React.useState("");
  const [images, setImages] = React.useState([]);

  const tabStyle = (part) => {
    return {
      borderBottom: showInfoTab === part ? "2px solid blue" : "",
      cursor: showInfoTab === part ? "default" : "pointer",
      marginRight: 16,
    };
  };

  React.useEffect(() => {
    let images = [];

    if (
      catalogData &&
      catalogData[catIdx.value] &&
      Array.isArray(catalogData[catIdx.value].Bildfile)
    ) {
      let size800 = catalogData[catIdx.value].Bildfile.filter(
        (e) => e.$.size === "800"
      );
      let size150 = catalogData[catIdx.value].Bildfile.filter(
        (e) => e.$.size === "150"
      );

      for (let i = 0; i < size800.length && i < size150.length; i++) {
        images.push({
          original: size800[i]._,
          thumbnail: size150[i]._,
          originalWidth: 800,
          originalHeight: 600,
        });
      }
    }

    setImages([...images]);
  }, [catalogData, catIdx]);

  React.useEffect(() => {
    if (Array.isArray(catalogData) && catalogData.length > catIdx.value) {
      if (
        catalogData[catIdx.value] &&
        Array.isArray(catalogData[catIdx.value].Textfile) &&
        catalogData[catIdx.value].Textfile.length > 0
      ) {
        axios
          .post(getHost() + "/giatadata/", {
            url: catalogData[catIdx.value].Textfile[0],
          })
          .then((response) => {
            //console.log(response);
            setCatalogText(response.data);
          });
      } else {
        setCatalogText("");
      }
      if (
        catalogData[catIdx.value] &&
        Array.isArray(catalogData[catIdx.value].AGB) &&
        catalogData[catIdx.value].AGB.length > 0
      ) {
        axios
          .post(getHost() + "/giatadata/", {
            url: catalogData[catIdx.value].AGB[0],
          })
          .then((response) => {
            //console.log(response);
            setAgbText(response.data);
          });
      } else {
        setAgbText("");
      }
    } else {
      setCatalogText("");
      setAgbText("");
    }
  }, [catalogData, catIdx]);

  return (
    <>
      <div className="hotelinfos">
        <div
          className="hotelinfos1"
          style={tabStyle("texts")}
          onClick={() => setShowInfoTab("texts")}
        >
          Beschreibung
        </div>
        {/*<div
          className="hotelinfos2"
          style={tabStyle("pictures")}
          onClick={() => setShowInfoTab("pictures")}
        >
          Bilder
        </div>*/}
        <div
          className="hotelinfos3"
          style={tabStyle("attributes")}
          onClick={() => setShowInfoTab("attributes")}
        >
          Ausstattung
        </div>
        <div
          className="hotelinfos4"
          style={tabStyle("ratings")}
          onClick={() => setShowInfoTab("ratings")}
        >
          Bewertungen
        </div>
        <div
          className="hotelinfos5"
          style={tabStyle("agbs")}
          onClick={() => setShowInfoTab("agbs")}
        >
          AGB
        </div>
        <div
          className="hotelinfos4"
          style={tabStyle("reviews")}
          onClick={() => setShowInfoTab("reviews")}
        >
          Kundenbewertungen
        </div>
        {hotelRegion.RegionClimate && (
          <div
            className="hotelinfos6"
            style={tabStyle("climate")}
            onClick={() => setShowInfoTab("climate")}
          >
            Klima
          </div>
        )}
        {hotelRegion.RegionClimate && (
          <div
            className="hotelinfos7"
            style={tabStyle("map")}
            onClick={() => setShowInfoTab("map")}
          >
            Karte
          </div>
        )}
      </div>
      {showInfo && showInfoTab === "texts" && (
        <div className={"giatatext"}>
          {catalogText && (
            <div
              className="hotelinfos9"
              dangerouslySetInnerHTML={{ __html: catalogText }}
            />
          )}
        </div>
      )}
      {showInfo && showInfoTab === "pictures" && (
        <div className="hotelinfos10">
          {catalogData && catalogData[catIdx.value] && (
            <ImageGallery items={images} lazyLoad={true} />
          )}
        </div>
      )}
      {showInfo && showInfoTab === "attributes" && (
        <div className="hotelinfos11">
          <HotelAttributes hotel={hotel} />
        </div>
      )}
      {showInfo && showInfoTab === "ratings" && (
        <div className="hotelinfos12">
          <HotelRatings hotel={hotel} />
        </div>
      )}
       {showInfo && showInfoTab === "reviews" && (
        <div className="hotelinfos12">
          <HotelReviews hotel={hotel} />
        </div>
      )}
      {showInfo && showInfoTab === "agbs" && (
        <div className={"giatatext"}>
          {catalogText && <div className="hotelinfos9" dangerouslySetInnerHTML={{ __html: agbText }} />}
        </div>
      )}
      {showInfo && showInfoTab === "climate" && hotelRegion && (
        <div className="hotelinfos13">
          <ClimateChart hotelRegion={hotelRegion} />
        </div>
      )}

      {showInfo && showInfoTab === "map" && hotel && hotel.HotelGeoPoint && (
        <div className="hotelinfos15">
          <ReactMap
            free={true}
            setNorthEast={() => { }}
            setSouthWest={() => { }}
            center={{
              lat: hotel.HotelGeoPoint.Latitude,
              lng: hotel.HotelGeoPoint.Longitude,
            }}
            visible={true}
            markers={[hotel].map((e) => {
              return {
                position: {
                  lat: e.HotelGeoPoint
                    ? e.HotelGeoPoint.Latitude
                    : [hotel].Hotel[0].HotelGeoPoint.Latitude,
                  lng: e.HotelGeoPoint
                    ? e.HotelGeoPoint.Longitude
                    : [hotel].Hotel[0].HotelGeoPoint.Longitude,
                },
                label: e.Name,
                id: e.HotelID,
                iataCode: e.HotelID,
              };
            })}
          />
        </div>
      )}
    </>
  );
}
